import React from 'react';

const AdminAnalytics = () => (
  <div className="admin-analytics">
    <h3>Analytics & Insights</h3>
    <p>Active users, most-watched, revenue reports — UI to be implemented.</p>
  </div>
);

export default AdminAnalytics;
